// extracted by mini-css-extract-plugin
export default {"zoomModal":"z4-z","image":"A4-z","button":"B4-z","isOverlayShown":"C4-z"};